import { memo, useCallback } from 'react'

import { useQuery } from '@tanstack/react-query'

import { Header } from '@shared/components/Header'
import { Content } from '@shared/layouts'
import { ActionsMenu } from 'domains/OriginGateways/Gateway'
import { useGatewayUpdateMutation } from 'hooks/mutations/origin'
import { gatewayRoute } from 'pages/NWPlatform/OriginGateways/Gateway/Routing'
import { gatewayQueryKeys } from 'services/queryKeys'

const StructureRaw = () => {
  const { gatewayId: gatewayId } = gatewayRoute.useParams()

  const gatewayQuery = useQuery(gatewayQueryKeys.detail({ gatewayId }))
  const gateway = gatewayQuery.data

  const { mutate: updateGateway, ...gatewayUpdateMutation } = useGatewayUpdateMutation()

  const handleUpdateAvcTaskName = useCallback(
    (title: string, closeCallback: () => void) => {
      updateGateway(
        {
          gatewayId,
          originGatewayEdit: {
            ...gateway,
            name: title,
          },
        },
        {
          onSettled: closeCallback,
        },
      )
    },
    [updateGateway, gatewayId, gateway],
  )

  return (
    <Content
      HeaderSlot={
        <Header
          title={gatewayQuery.data?.name ?? ''}
          isLoading={gatewayQuery.isLoading}
          isSaving={gatewayUpdateMutation.isPending}
          onSave={handleUpdateAvcTaskName}
          Actions={<ActionsMenu />}
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
